import React, { ReactNode } from "react"
import styles from "./styles.module.scss"
import { Card, CardProps } from "antd"
import moment from "moment"

import { useTranslation } from "react-i18next"

interface Props extends CardProps {
  date: string
  Content: ReactNode
  actions?: ReactNode[]
}

const OverviewCardWithDate: React.FC<Props> = ({ date, Content, actions }) => {
  const { t } = useTranslation()

  return (
    <Card actions={actions} className={styles.eventCard}>
      <div className={styles.header}>
        <div className={styles.headerDate}>
          <p className={styles.day}>
            {t(`date.days.long.${moment(date).locale("en").format("dddd")}`)}
          </p>
          <p className={styles.dayNumber}>{moment(date).format("DD")}</p>
          <p className={styles.month}>
            {t(`date.months.short.${moment(date).locale("en").format("MMMM")}`)}
          </p>
        </div>
        <div className={styles.titleContainer}>{Content}</div>
      </div>
    </Card>
  )
}

export default OverviewCardWithDate
